import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { Permissions, userHasPermission } from 'services/Authorization';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useHiringAuthorityProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canRequestDoNotContact: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotContactFromProfile),
    canRequestDoNotEngage: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotEngageFromProfile),
    canUseDailyPlanTask: userHasPermission(Permissions.DailyPlan.CanUseModule),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    shouldShowKeywords: checkIfFeatureFlagEnabled(FeatureFlags.ContactKeywordTags)
  };
};
